export const siderColor = '#FFF';
